/* Neoballs desktop header: hover effects (Hover Lab "00 Prototype") and the scroll collapse (Scroll Lab rig 41).
   The markup is static (snippets/nb-header.liquid); this script only animates it.
   - Toggles class "c" on .nb-header when window.scrollY > 4 (passive listener + rAF). CSS does the collapse.
   - Hover / keyboard focus on an item runs that icon's effect. One rAF loop runs only while something is moving.
   - prefers-reduced-motion: no loops, no pull, no spins; CSS falls back to a colour change.
   - Below 1024 px the theme hides the header; the scroll handler does nothing there and no effect can start. */
(function () {
'use strict';
if (window.NBHeader) return;

/* ---------- geometry (icon space: viewBox 0 0 103.92 120, centre 51.96,60) ---------- */
const CX = 51.96, CY = 60, PI = Math.PI, TAU = PI * 2;
const f2 = n => Math.round(n * 100) / 100, fx1 = n => n.toFixed(1);
const cl = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x));
const NS = 120;                                   // outline samples, 3 degrees apart, from the top vertex
const THS = Float32Array.from({length: NS}, (_, i) => -PI / 2 + i * TAU / NS);
const R0 = 57.125;                                // ring midline, centre to vertex
const hexR = t => { const P = PI / 3, a = (((t + PI / 2) % P) + P) % P; return R0 * Math.cos(PI / 6) / Math.cos(a - PI / 6); };
const arrOf = fn => Float32Array.from(THS, fn);
const HEXA = arrOf(hexR);
const HEX_D0 = 'M51.96,2.87L101.44,31.43L101.44,88.57L51.96,117.13L2.48,88.57L2.48,31.43Z';
// distance from the icon centre along each sample angle to a circle (Frame Shift targets)
const circR = (px, py, r) => arrOf(t => {
  const dx = Math.cos(t), dy = Math.sin(t), ox = CX - px, oy = CY - py, b = dx * ox + dy * oy;
  return -b + Math.sqrt(b * b - (ox * ox + oy * oy - r * r));
});
const FS_ARMA = circR(CX, CY, 50), FS_LENS = circR(46, 52, 43);

// closed curve through the midpoints of the samples: circles read smooth, spikes stay crisp
function smooth(p) {
  const n = p.length, mx = i => (p[i][0] + p[(i + 1) % n][0]) / 2, my = i => (p[i][1] + p[(i + 1) % n][1]) / 2;
  let d = `M${fx1(mx(n - 1))},${fx1(my(n - 1))}`;
  for (let i = 0; i < n; i++) d += `Q${fx1(p[i][0])},${fx1(p[i][1])} ${fx1(mx(i))},${fx1(my(i))}`;
  return d + 'Z';
}
const radPts = rs => Array.from(rs, (r, i) => [CX + r * Math.cos(THS[i]), CY + r * Math.sin(THS[i])]);

// damped springs, stepped at 240 Hz so stiff ones stay stable
function spr(o, k, target, K1, C1, dt) {
  let x = o[k], v = o[k + 'V'] || 0;
  const n = Math.max(1, Math.ceil(dt * 240)), h = dt / n;
  for (let i = 0; i < n; i++) { v += (-K1 * (x - target) - C1 * v) * h; x += v * h; }
  o[k] = x; o[k + 'V'] = v;
  return Math.abs(x - target) > 1e-3 || Math.abs(v) > 1e-3;
}
function sprArr(r, v, tg, K1, C1, dt) {
  const n = Math.max(1, Math.ceil(dt * 240)), h = dt / n, len = r.length;
  for (let s = 0; s < n; s++) for (let i = 0; i < len; i++) { v[i] += (-K1 * (r[i] - tg[i]) - C1 * v[i]) * h; r[i] += v[i] * h; }
  for (let i = 0; i < len; i++) if (Math.abs(r[i] - tg[i]) > .02 || Math.abs(v[i]) > .05) return true;
  return false;
}

/* ---------- one animation loop, running only while something moves ---------- */
const live = new Set();
let raf = 0, last = 0;
function wake(t) { live.add(t); if (!raf) { last = performance.now(); raf = requestAnimationFrame(loop); } }
function loop(now) {
  const dt = Math.min(.05, Math.max(0, now - last) / 1000);
  last = now;
  for (const t of live) {
    let alive = false;
    try { alive = t.step(dt); } catch (err) { console.error('[nb-header]', err); }
    if (!alive) live.delete(t);
  }
  raf = live.size ? requestAnimationFrame(loop) : 0;
}

/* ---------- outline effects (Frame Shift, Ferrofluid, lens) ---------- */
function radialInit(svg, s) {
  s.plate = svg.querySelector('.nb-sp'); s.frame = svg.querySelector('.nb-sf'); s.glyph = svg.querySelector('.nb-sg');
  s.r = Float32Array.from(HEXA); s.rv = new Float32Array(NS); s.gs = 1;
}
const setD = (s, d) => { s.plate.setAttribute('d', d); s.frame.setAttribute('d', d); };
const drawR = s => setD(s, smooth(radPts(s.r)));
const gT = (s, sc) => s.glyph.setAttribute('transform', `translate(${CX} ${CY}) scale(${sc.toFixed(3)}) translate(${-CX} ${-CY})`);
function LENS(s, m, q) {   // m merges the lens into the new rim; q flies the handle over on an arc, spinning once
  const cx = 47.5 - 1.5 * m, cy = 51.59 + .41 * m, k = 1 + (40.5 / 22.33 - 1) * m;
  s.rim.setAttribute('cx', f2(cx)); s.rim.setAttribute('cy', f2(cy)); s.rim.setAttribute('r', f2(Math.max(0, 26.5 + 16.5 * m))); s.rim.setAttribute('stroke-width', f2(4 + m));
  s.lens.setAttribute('transform', `translate(${f2(cx)} ${f2(cy)}) scale(${k.toFixed(3)}) translate(-47.5 -51.59)`);
  const e = q < .5 ? 4 * q ** 3 : 1 - (-2 * q + 2) ** 3 / 2, lift = Math.sin(PI * e);
  const hx = 65.47 + 23.13 * e + 9 * lift, hy = 89.33 + 5.27 * e - 14 * lift;
  s.hand.setAttribute('transform', `translate(${f2(hx)} ${f2(hy)}) rotate(${f2(-380 * e)}) scale(${f2(1 + .25 * e)}) translate(-65.47 -89.33)`);
}

const SH = {
  armadillo: {   // Frame Shift into a ball, with the steel plate and glint clipped to the moving outline
    init(svg, s) { radialInit(svg, s); s.outs = [...svg.querySelectorAll('.nb-pa')]; },
    tick(s, dt) {
      let mv = sprArr(s.r, s.rv, s.hov ? FS_ARMA : HEXA, 240, 15, dt);
      mv = spr(s, 'gs', s.hov ? 1.2 : 1, 260, 20, dt) || mv;
      drawR(s); gT(s, s.gs);
      const d = s.plate.getAttribute('d'); s.outs.forEach(e => e.setAttribute('d', d));
      return mv;
    },
    rest(s) { setD(s, HEX_D0); s.glyph.removeAttribute('transform'); s.outs.forEach(e => e.setAttribute('d', HEX_D0)); }
  },
  magnets: {     // Ferrofluid: spikes grow from the rim on the side facing the pointer (Field Lines are CSS)
    init(svg, s) { s.f = Float32Array.from(HEXA, r => r + 1.5); s.fv = new Float32Array(NS); s.tg = new Float32Array(NS); s.path = svg.querySelector('.nb-ferro'); },
    tick(s, dt) {
      if (s.hov) {
        let psi = -PI / 3;
        if (ptr && s.box) psi = Math.atan2(ptr.y - (s.box.top + s.box.height / 2), ptr.x - (s.box.left + s.box.width / 2));
        for (let i = 0; i < NS; i++) {
          const d = THS[i] - psi, w = Math.pow(Math.max(0, Math.cos(d)), 2.2), sp = Math.pow(Math.max(0, Math.cos(12 * d)), 5);
          s.tg[i] = HEXA[i] + 1.5 + w * (5 + 17 * sp * (.85 + .15 * Math.sin(s.time * 7 + i * .9)));
        }
      } else for (let i = 0; i < NS; i++) s.tg[i] = HEXA[i] + 1.5;
      const mv = sprArr(s.f, s.fv, s.tg, 240, 14, dt);
      s.path.setAttribute('d', smooth(radPts(s.f)));
      return s.hov || mv;
    },
    rest(s) { s.path.setAttribute('d', HEX_D0); }
  },
  search: {      // the hexagon rounds into a circle, the lens grows until its rim is that circle, the handle swings over
    init(svg, s) { radialInit(svg, s); s.lens = svg.querySelector('.nb-ll'); s.rim = svg.querySelector('.nb-lr'); s.hand = svg.querySelector('.nb-lh'); s.m = 0; s.q = 0; },
    tick(s, dt) {
      let mv = sprArr(s.r, s.rv, s.hov ? FS_LENS : HEXA, 240, 15, dt);
      mv = spr(s, 'm', s.hov ? 1 : 0, 240, 24, dt) || mv;
      s.q = cl(s.q + (s.hov ? dt / .8 : -dt / .65));
      drawR(s); LENS(s, s.m, s.q);
      return mv || (s.hov ? s.q < 1 : s.q > 0);
    },
    rest(s) { setD(s, HEX_D0); s.m = s.mV = s.q = 0; LENS(s, 0, 0); }
  }
};
function outlineTicker(it, key, svg) {
  const s = {hov: false, ht: 0, time: 0}, D = SH[key];
  D.init(svg, s);
  it.s = s;
  return {step(dt) {
    s.time += dt; if (s.hov) s.ht += dt;
    const alive = D.tick(s, dt);
    if (!alive && !s.hov) D.rest(s);
    return alive;
  }};
}

/* ---------- Surprise: custom chip C9 (big chip, motion blur) ---------- */
const GA = R0 * Math.cos(PI / 6);
const hexA = a => { const s = PI / 3; return GA / Math.cos(a - Math.round(a / s) * s); };
function ringPath(t, rc) {
  let d = '';
  for (let k = 0; k < 120; k++) { const a = -PI / 2 + k * TAU / 120, r = hexA(a) * (1 - t) + rc * t;
    d += (k ? 'L' : 'M') + (CX + r * Math.cos(a)).toFixed(2) + ',' + (CY + r * Math.sin(a)).toFixed(2); }
  return d + 'Z';
}
const eBack = x => { x = cl(x); return 1 + 2.4 * Math.pow(x - 1, 3) + 1.4 * Math.pow(x - 1, 2); };
const eOut = x => 1 - Math.pow(1 - cl(x), 3);
const PX = 59, PY = 45.64;          // the dark hexagon in the middle of the Surprise logo: the spin turns on this point
const CXW = 1080, CXTRAIL = 20;     // 3 turns/s; blur copies trail 20 ms of spin
const BLUR_N = 6;
function drawGlyph(I, p) {
  const e = eOut(p * 3.2), s = 1 + (I.gs - 1) * e, x = PX + (CX - PX) * e, y = PY + (CY - PY) * e;
  const tf = a => `translate(${x.toFixed(3)} ${y.toFixed(3)}) rotate(${a.toFixed(2)}) scale(${s.toFixed(4)}) translate(${-PX} ${-PY})`;
  I.gg.setAttribute('transform', tf(I.th));
  const span = I.w * CXTRAIL / 1000;
  if (span > .6) {
    I.blur.forEach((c, k) => { c.setAttribute('transform', tf(I.th - span * (BLUR_N - 1 - k) / (BLUR_N - 1))); c.setAttribute('opacity', (1 / (k + 1)).toFixed(3)); c.removeAttribute('display'); });
    I.gg.setAttribute('opacity', (1 / BLUR_N).toFixed(3)); I.blurOn = true;
  } else if (I.blurOn) { I.blur.forEach(c => c.setAttribute('display', 'none')); I.gg.setAttribute('opacity', 1); I.blurOn = false; }
}
function setDash(el, period, gap, off) {
  if (gap < .05) { el.setAttribute('stroke-dasharray', 'none'); return; }
  el.setAttribute('stroke-dasharray', `${(period - gap).toFixed(2)} ${gap.toFixed(2)}`); el.setAttribute('stroke-dashoffset', off.toFixed(2));
}
function chipRender(I) {   // the rim bows into six thick segments of a poker chip; the logo slides onto the centre and spins
  const p = I.p, t = Math.min(1.035, eBack((p - .12) / .88)), tc = Math.min(1, t);
  I.gp.setAttribute('d', ringPath(tc, GA));
  I.gr.setAttribute('d', ringPath(t, 46.2)); I.gr.setAttribute('stroke-width', (5 + 1.5 * tc).toFixed(2)); setDash(I.gr, 60, 11 * tc, -5.5 * tc);
  I.edge.setAttribute('opacity', tc.toFixed(3));
  drawGlyph(I, p);
}
function chipStep(I, dt) {
  if (I.h) { I.set = null; I.w = CXW; I.th += I.w * dt; }
  else if (I.w > 0 || I.th !== 0) {
    /* stop upright: keep turning, then brake hard into the next whole turn (+4 degrees) and spring back onto it.
       A brief brush that has barely turned springs straight back instead. */
    const BR = 2600;
    if (!I.set) { const base = Math.floor(I.th / 360) * 360, rel = I.th - base;
      if (rel < 50 && I.w < 160) I.set = {T: base, ph: 1};
      else I.set = {T: Math.max(base + 360, Math.ceil((I.th + I.w * I.w / (2 * BR)) / 360) * 360), ph: 0}; }
    const S = I.set;
    if (S.ph === 0) { const d = S.T + 4 - I.th;
      if (d <= .02 || (I.w <= 2 && d < 8)) S.ph = 1;
      else { const need = I.w * I.w / (2 * d); if (need >= BR * .98) I.w = Math.max(0, I.w - need * dt); else if (I.w < 240) I.w = Math.min(240, I.w + 700 * dt); I.th += I.w * dt; } }
    if (S.ph === 1) { const n = Math.max(1, Math.ceil(dt * 240)), h = dt / n, k = 220, c = 2 * .5 * Math.sqrt(k);
      for (let i = 0; i < n; i++) { I.w += (k * (S.T - I.th) - c * I.w) * h; I.th += I.w * h; }
      if (Math.abs(S.T - I.th) < .05 && Math.abs(I.w) < 2) { I.th = 0; I.w = 0; I.set = null; } }
  }
  const open = I.h || (I.set && I.set.ph === 0 && I.set.T + 4 - I.th > 30);
  I.p = cl(I.p + (open ? 1 : -1) * dt / .48);
  chipRender(I);
  return I.h || I.p > 0 || I.w > 0 || I.th !== 0;
}
function chipTicker(it, svg) {
  const q = s => svg.querySelector(s);
  const I = {gp: q('.nb-chp'), gr: q('.nb-chr'), gg: q('.nb-chg'), edge: q('.nb-che'), blur: [], blurOn: false, h: false, p: 0, th: 0, w: 0, set: null};
  I.gs = +(I.gg.getAttribute('data-gs') || .735);
  for (let k = 0; k < BLUR_N - 1; k++) {
    const c = I.gg.cloneNode(true); c.setAttribute('class', 'nb-chb'); c.setAttribute('display', 'none');
    I.gg.parentNode.insertBefore(c, I.gg); I.blur.push(c);
  }
  chipRender(I);
  it.I = I;
  return {step: dt => chipStep(I, dt)};
}

/* ---------- state ---------- */
let root, items = [], arma = null, ptr = null, collapsed = false, rm = false, desk = null, rmq = null, scrollQueued = false, pullQueued = false, flipT = 0;

function fxAllowed() { return !collapsed && !rm; }
function setHov(it, on) {
  it.on = on;
  it.el.classList.toggle('nb-on', on);
  applyFx(it);
}
function applyFx(it) {
  const fx = it.on && fxAllowed();
  if (fx === it.fx) return;
  it.fx = fx;
  it.el.classList.toggle('nb-hov', fx);
  if (it.s) {
    if (fx && !it.s.hov) { it.s.ht = 0; it.s.box = it.ic.getBoundingClientRect(); }
    it.s.hov = fx; wake(it.tk);
  }
  if (it.I) { it.I.h = fx; wake(it.tk); }
}

/* 17 Magnet Pull: only the Armadillo leans toward the pointer, before you reach it, and springs back */
function pullAt(px, py) {
  const r = arma.ic.getBoundingClientRect();
  const dx = px - (r.left + r.width / 2), dy = py - (r.top + r.height / 2);
  const f = Math.max(0, 1 - Math.hypot(dx, dy) / (r.width * 1.6));
  const s = f * f * (3 - 2 * f), u = 103.92 / r.width, st = arma.el.style;
  st.setProperty('--tx', `${f2(dx * .34 * s)}px`);
  st.setProperty('--ty', `${f2(dy * .34 * s)}px`);
  st.setProperty('--gx', `${f2(dx * .14 * s * u)}px`);
  st.setProperty('--gy', `${f2(dy * .14 * s * u)}px`);
}
function pullReset() {
  if (!arma) return;
  arma.el.classList.remove('nb-trk');
  ['--tx', '--ty', '--gx', '--gy'].forEach(p => arma.el.style.removeProperty(p));
}
function onPointerMove(e) {
  ptr = {x: e.clientX, y: e.clientY};
  if (!arma || !fxAllowed() || pullQueued) return;
  pullQueued = true;
  requestAnimationFrame(() => {
    pullQueued = false;
    if (!ptr || !fxAllowed()) return;
    arma.el.classList.add('nb-trk');
    pullAt(ptr.x, ptr.y);
  });
}
function onPointerLeave() { ptr = null; pullReset(); }

/* ---------- scroll: class "c" past 4 px ---------- */
function scrollY() { return window.pageYOffset || document.documentElement.scrollTop || 0; }
function setCollapsed(c) {
  if (c === collapsed) return;
  collapsed = c;
  root.classList.toggle('c', c);
  if (c) pullReset();
  items.forEach(applyFx);
  if (rm) {   // reduced motion: moved parts fade in at their new place
    root.classList.remove('nb-flip'); void root.offsetWidth; root.classList.add('nb-flip');
    clearTimeout(flipT); flipT = setTimeout(() => root.classList.remove('nb-flip'), 260);
  }
}
function syncScroll() {
  scrollQueued = false;
  if (desk && !desk.matches) return;
  setCollapsed(scrollY() > 4);
}
function onScroll() { if (!scrollQueued) { scrollQueued = true; requestAnimationFrame(syncScroll); } }
function syncInstant() {   // first paint, or back to desktop width: jump to the right state without transitions
  root.classList.add('nb-inst');
  if (!desk || desk.matches) setCollapsed(scrollY() > 4);
  void root.offsetWidth;
  requestAnimationFrame(() => requestAnimationFrame(() => root.classList.remove('nb-inst')));
}
function setRM(on) {
  rm = on;
  root.classList.toggle('nb-rm', on);
  if (on) pullReset();
  items.forEach(applyFx);
}
const onMQ = (mq, fn) => { if (!mq) return; if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); };

/* ---------- wiring ---------- */
function init() {
  root = document.querySelector('.nb-header');
  if (!root || root._nb) return;
  root._nb = true;
  try { desk = window.matchMedia('(min-width: 1024px)'); rmq = window.matchMedia('(prefers-reduced-motion: reduce)'); } catch (_) {}
  rm = !!(rmq && rmq.matches);
  root.classList.toggle('nb-rm', rm);

  items = [...root.querySelectorAll('.nb-it')].map(el => {
    const it = {el, key: el.getAttribute('data-k'), ic: el.querySelector('.nb-ic'), on: false, fx: false, t: 0};
    const svg = el.querySelector('.nb-ico > svg');
    try {
      if (SH[it.key] && svg) it.tk = outlineTicker(it, it.key, svg);
      else if (it.key === 'surprise' && svg) it.tk = chipTicker(it, svg);
    } catch (err) { console.error('[nb-header]', err); }
    if (it.key === 'armadillo') arma = it;

    el.addEventListener('pointerenter', () => { clearTimeout(it.t); setHov(it, true); });
    el.addEventListener('pointerleave', e => {
      if (e.pointerType === 'mouse') setHov(it, false);
      else { clearTimeout(it.t); it.t = setTimeout(() => setHov(it, false), 1400); }   // touch / pen: let the effect play
    });
    el.addEventListener('focus', () => { let fv = true; try { fv = el.matches(':focus-visible'); } catch (_) {} if (fv) setHov(it, true); });
    el.addEventListener('blur', () => { clearTimeout(it.t); setHov(it, false); });
    if (it.key === 'contact') el.addEventListener('click', e => {
      const jq = window.jQuery;
      if (typeof jq === 'function') { e.preventDefault(); jq('.contact_maincontainer').slideToggle(); }
    });
    return it;
  });

  root.addEventListener('pointermove', onPointerMove, {passive: true});
  root.addEventListener('pointerleave', onPointerLeave);
  window.addEventListener('scroll', onScroll, {passive: true});
  // safety net: a pointer that jumps straight into an iframe (the homepage video) may never send pointerleave
  const releaseAll = () => { onPointerLeave(); items.forEach(it => { clearTimeout(it.t); if (it.on && document.activeElement !== it.el) setHov(it, false); }); };
  window.addEventListener('blur', releaseAll);
  document.addEventListener('visibilitychange', () => { if (document.hidden) releaseAll(); });
  onMQ(desk, () => { if (desk.matches) syncInstant(); });
  onMQ(rmq, () => setRM(rmq.matches));
  syncInstant();
}

window.NBHeader = {
  init,
  get collapsed() { return collapsed; },
  get running() { return live.size; }   // number of things the animation loop is moving right now (0 when idle)
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();
